module.exports = __webpack_public_path__ + "static/media/image_5.83894e4b.png";